import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchCustomerOrders,
  SearchCustomerOrdersVariables
} from "./types/SearchCustomerOrders";

export const searchCustomerOrders = gql`
  ${pageInfoFragment}
  query SearchCustomerOrders(
    $after: String
    $first: Int!
    $query: String!
    $customer: String
    $sortBy: OrderSortingInput
  ) {
    search: orders(
      after: $after
      first: $first
      filter: { search: $query, customer: $customer }
      sortBy: $sortBy
    ) {
      edges {
        node {
          id
          created
          number
          paymentStatus
          total {
            gross {
              currency
              amount
            }
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<
  SearchCustomerOrders,
  SearchCustomerOrdersVariables
>(searchCustomerOrders);
